// Poster themes — mirrors pipeline/kathakala/poster_prompt.py presets,
// which is itself a verbatim port of the kathakala-poster Claude skill's
// references/presets.md. Keep the ids identical across both so the UI
// can pass a theme id straight to the Python generator.

export const POSTER_THEMES = [
  {
    id: "bold-spring",
    name: "Bold Spring — Fire & Bloom",
    tagline: "Explosive spring energy (recommended)",
    palette: ["#FF5500", "#E42D6A", "#FFC300", "#046307", "#C9A84C"],
  },
  {
    id: "spring",
    name: "Spring — Fresh & Vibrant",
    tagline: "Soft vibrant spring, original",
    palette: ["#8FBF6B", "#F6D155", "#E89BA6", "#C9A84C", "#88C0B8"],
  },
  {
    id: "monsoon",
    name: "Monsoon — Mystical & Dramatic",
    tagline: "Indigo rain, evocative depth",
    palette: ["#2D3E7C", "#5A6B8C", "#C0C7CF", "#046307", "#C9A84C"],
  },
  {
    id: "festive",
    name: "Festive / Diwali — Rich & Celebratory",
    tagline: "Burgundy + gold, opulent",
    palette: ["#7A1E2B", "#C9A84C", "#046307", "#C4402E", "#F5E6C8"],
  },
  {
    id: "winter",
    name: "Winter / Night Sky — Serene & Starlit",
    tagline: "Midnight + silver, meditative",
    palette: ["#1A2B5F", "#5B5F7E", "#B0B7C4", "#C9A84C", "#8FBFE0"],
  },
  {
    id: "harvest",
    name: "Harvest / Autumn — Earthy & Warm",
    tagline: "Terracotta + amber, rooted",
    palette: ["#A0522D", "#E27B00", "#7B3F1D", "#046307", "#C9A84C"],
  },

  // ─── Culture / Literature / Tradition themes ───
  {
    id: "palm-leaf",
    name: "Palm-Leaf Manuscript — తాళపత్ర గ్రంథం",
    tagline: "Sepia parchment + scholarly heritage",
    palette: ["#8B6F47", "#D4A843", "#3E2A14", "#5C4427", "#F2E2BD"],
  },
  {
    id: "kuchipudi",
    name: "Kuchipudi Stage — శాస్త్రీయ నృత్యం",
    tagline: "Crimson silk + brass lamp + raised stage",
    palette: ["#9B1B30", "#C9A84C", "#FFD700", "#1E4D2B", "#F5E6C8"],
  },
  {
    id: "burra-katha",
    name: "Burra-Katha Folk — బుర్రకథ",
    tagline: "Folk percussion + bold tribal energy",
    palette: ["#C8102E", "#F1B41A", "#0E3B43", "#7A3E1F", "#E5DCC5"],
  },
  {
    id: "saraswati",
    name: "Saraswati's Veena — సరస్వతీ వాణి",
    tagline: "Pearl + lotus + sacred wisdom",
    palette: ["#F8F4E8", "#C9A84C", "#5C8FBF", "#E9D7B6", "#3D5A80"],
  },
  {
    id: "kalamkari",
    name: "Kalamkari Heritage — కలంకారీ",
    tagline: "Indigo + rust + hand-block patterns",
    palette: ["#1F3A5F", "#B85525", "#C9A04A", "#E5DCC5", "#3D5C3A"],
  },
  {
    id: "mahakavya",
    name: "Mahakavya — మహాకావ్యం",
    tagline: "Epic poetry + celestial divine palette",
    palette: ["#0C1B3A", "#C9A04A", "#E8D5A0", "#5B2A3E", "#E5E5E5"],
  },

  // ─── Seasonal / Topical themes ───
  {
    id: "pride",
    name: "Pride — Rainbow Celebration",
    tagline: "Rainbow celebration + inclusive joy",
    palette: ["#E63946", "#F4A024", "#2A9D8F", "#3D5A80", "#7B4B94"],
  },
  {
    id: "championship",
    name: "Championship — Game Day",
    tagline: "Game-day victory + stadium energy",
    palette: ["#0B3D91", "#C8102E", "#FFB81C", "#1E222B", "#E8E8E8"],
  },
  {
    id: "july4th",
    name: "July 4th — Stars & Stripes",
    tagline: "Fireworks + red-white-blue patriotic evening glow",
    palette: ["#B22234", "#FFFFFF", "#3C3B6E", "#C9A84C", "#8FA8C9"],
  },
  {
    id: "indo-american",
    name: "Indo-American — Tricolor & Stars",
    tagline: "Saffron-green heritage meets red-white-blue, one storytelling family",
    palette: ["#FF9933", "#138808", "#B22234", "#002868", "#F5F1E6"],
  },
  {
    id: "america250",
    name: "America 250 — Semiquincentennial",
    tagline: "250 years of independence, a milestone celebration",
    palette: ["#14213D", "#BF0A30", "#FFFFFF", "#C5A253", "#E8A33D"],
  },

  // ─── Books & Writing themes ───
  {
    id: "library",
    name: "Storyteller's Library — గ్రంథాలయం",
    tagline: "Warm bookshelves + the love of reading",
    palette: ["#5C3A21", "#C9A84C", "#7B9E89", "#E8DCC0", "#8B3A3A"],
  },
  {
    id: "inkwell",
    name: "Writer's Craft — కలం & ఇంక్",
    tagline: "Pen, ink & the craft of writing",
    palette: ["#1B2A4A", "#C9A04A", "#6E4B2A", "#E5DCC5", "#4A6B5A"],
  },
];

export const DEFAULT_POSTER_THEME_ID = "bold-spring";

export function getPosterTheme(id) {
  return POSTER_THEMES.find((t) => t.id === id) || null;
}
